export default {
    filter: 'Фильтр',
    filterStatus: {
        all: 'Все',
        applications: {
            inwork: 'На рассмотрении',
            closed: 'Приняты',
            rejected: 'Отклонены',
        },
        approvals: {
            inwork: 'На согласовании',
            approved: 'Согласовано',
            rejected: 'Отклонено согласующим',
            canceled: 'Аннулировано отправителем'
        },
        metroApprovals: {
            inwork: 'На согласовании',
            closed: 'Согласовано',
            canceled: 'Аннулированные',
            rejected: 'Отклонены',
        },
        metro: {
            all: 'Все',
            draft: 'Черновик',
            inwork: 'На согласовании',
            closed: 'Согласованные',
            rejected: 'Отклоненные',
            canceled: 'Аннулированы',
        },
        project: {
            request:   'Запрос',
            inwork:    'В работе',
            partially: 'Частично выполнены',
            rejected:  'Отклонены',
            held:      'Замороженные',
            done:      'Выполненные',
            canceled:  'Аннулированные',
            closed:    'Архив',
        },
        projectMass: {
            close:     'Архив',
            hold:      'Замороженные',
            request:   'Запрос',
            inwork:    'В работе',
            done:      'Выполненные',
            canceled:  'Аннулированные',
        },
        worksheet: {
            finalist: 'Финалисты',
            outFinalist: 'Искл.из финалистов',
            candidates: 'Кандидаты',
            outCandidates: 'Искл.из кандидатов',
            applicant: 'Претенденты',
            outApplicant: 'Искл.из претендентов',
            probation: 'Трудоустроены (исп.срок)',
            probationFail: 'Не прошли исп.срок',
            probationSuccess: 'Трудоустроены'
        },
        worksheetMass: {
            groupByStage: 'Группировать по состоянию',
            groupByCategory: 'Группировать по категории'
        },
        actionVacancy: {
            planning: 'Планирование мероприятия',
            gathering: 'Оценка потребностей',
            event: 'Запись на мероприятие',
            registration: 'Запись на мероприятие',
        },
        approvalApplications: {
            inwork: 'На рассмотрении',
            cancel: 'Отклонено',
            close: 'Подтверждено',
            annul: 'Отклонено пользователем',
        },
        courses: {
            assessment: 'Оценка',
            training: 'Обучение'
        },
        events: {
            actions: 'Очные мероприятия',
            courses: 'Дистанционные мероприятия',
        },
        trainer: {
            request: 'Запрос',
            work: 'В работе',
            hold: 'Замороженные',
            done: 'Выполненные',
            annul: 'Аннулированные',
            close: 'Архив'
        },
        news: {
            closed: 'Закрытые новости',
            inwork: 'Новости в работе'
        }
    },
};
